import { render } from "./ColumnMappingStep.vue?vue&type=template&id=48154916&scoped=true"
import script from "./ColumnMappingStep.vue?vue&type=script&lang=ts"
export * from "./ColumnMappingStep.vue?vue&type=script&lang=ts"

import "./ColumnMappingStep.vue?vue&type=style&index=0&id=48154916&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-48154916"

export default script